import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { format } from 'date-fns';
import _ from 'lodash';
import {
  Select,
  MenuItem
} from '@material-ui/core';
import classNames from 'classnames';

import './MarketsGrid.scss';
import formatOdds from '../../utils/formatOdds';
import Icon from '../Icon/Icon';

class MarketsGrid extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedTag: ''
    };
  }

  async componentDidMount() {
    await this.props.getSportEventByCode(this.props.match.params.id);

    if (this.props.event && this.props.event.markets.length > 0) {
      this.setState({ selectedTag: this.props.event.markets[0].id });
    }
  }

  addToBetslip = (sportEvent, tournamentName, market, outcome) => async (event) => {
    event.preventDefault();
    await this.props.addBet({
      eventCode: sportEvent.code,
      providerCode: sportEvent.provider.id,
      odds: outcome.value,
      marketOutcomeCode: outcome.code || outcome.id,
      marketCode: market.marketCode,
      marketName: market.marketName || market.name,
      jsonLabel: outcome.name,
      tournamentName: sportEvent.tournament.name,
      tournament: sportEvent.tournament,
      datetime: sportEvent.scheduled * 1000,
      sport: sportEvent.sport.name,
      outcome: outcome.name,
      eventName: sportEvent.name,
      venue: sportEvent.venueName
    });
  }

  removeFromBetslip = (index) => event => {
    event.preventDefault();

    this.props.removeBetAtIndex(index);
  }

  selectTag = () => event => {
    event.preventDefault();

    this.setState({ selectedTag: event.target.value });
  }

  renderHeader = () => {
    const {
      t,
      history,
      event: {
        markets,
        name,
        scheduled,
        sport,
        tournament
      }
    } = this.props;

    return (
      <div className="markets-grid__header">
        <div className="markets-grid__scroller">
          <div className="markets-grid__track">
            <div className="markets-grid__back">
              <Icon
                icon="arrow"
                className="markets-grid__arrow"
                onClick={ history.goBack }
              />
              <span onClick={ history.goBack }>{ t('marketsGrid.backToSports') }</span>
              <Icon icon="graph" className="markets-grid__event-graph" />
            </div>
            <div className="markets-grid__teams">
              <span>{ name }</span>
            </div>
            <div className="markets-grid__date">
              <span>{ format(scheduled, 'Do MMMM yyyy, dddd') }</span>
            </div>
            <div className="markets-grid__info-filter">
              <span className="markets-grid__icon sport-icon">{ sport.icon }</span>
              <span className="markets-grid__tournament">{ tournament.name }</span>
              <div>
                {
                  markets.length > 0 && (
                    <Select
                      disableUnderline={ true }
                      className="markets-grid__tournament-market-dropdown"
                      MenuProps={ { className: 'markets-grid__tournament-market-popover' } }
                      value={ this.state.selectedTag }
                      onChange={ this.selectTag }
                      IconComponent={ () => <Icon icon="arrow" /> }
                    >
                      {
                        _.map(markets, (m, mi) => {
                          return (
                            <MenuItem
                              key={ mi }
                              className="markets-grid__tournament-market-option"
                              value={ m.id }
                            >
                              { m.name }
                            </MenuItem>
                          );
                        })
                      }
                    </Select>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderMarkets = () => {
    const { event, bets, selectedOddsType } = this.props;
    const tag = _.find(event.markets, m => m.id === this.state.selectedTag);

    return (
      <div className="markets-grid__markets">
        {
          tag && _.map(tag.markets, (market, i) => {
            return (
              <div key={ i } className="markets-grid__wrapper">
                <div className="markets-grid__title">
                  { `${ market.marketName } ${ market.specifiers.length !== 0 && Object.values(market.specifiers)[0] }` }
                </div>
                <div className="markets-grid__event-odds-container">
                  {
                    market.outcomes.length > 0 && (
                      _.map(market.outcomes, (o, oi) => {
                        const index = _.findIndex(bets, {
                          eventCode: event.code,
                          marketCode: market.marketCode,
                          marketOutcomeCode: market.outcomes[oi].id
                        });

                        return (
                          <div
                            key={ oi }
                            className={
                              classNames({
                                'markets-grid__event-odds': true,
                                'markets-grid__event-odds--selected': index !== -1
                              })
                            }
                            onClick={ index !== -1 ? this.removeFromBetslip(index) : this.addToBetslip(event, event.tournament.name, market, o) }
                          >
                            <p className="markets-grid__odd-name">{ market.headers ? market.headers[oi][1].outcome : o.name }</p>
                            { formatOdds(o.value, selectedOddsType) }
                          </div>
                        );
                      })
                    )
                  }
                </div>
              </div>
            );
          })

        }
      </div>
    );
  }

  render() {
    return (
      <div className="markets-grid">
        { !_.isEmpty(this.props.event) && this.renderHeader() }

        { !_.isEmpty(this.props.event) && this.renderMarkets() }
      </div>
    );
  }
}

MarketsGrid.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  match: PropTypes.object,
  event: PropTypes.object,
  bets: PropTypes.array,
  addBet: PropTypes.func,
  removeBetAtIndex: PropTypes.func,
  getSportEventByCode: PropTypes.func,
  selectedOddsType: PropTypes.string
};

const mapState = state => ({
  event: state.events.selectedEvent,
  bets: state.betslip.bets,
  selectedOddsType: state.odds.selectedOddsType
});

const mapDispatch = dispatch => ({
  addBet: (obj) => dispatch.betslip.addBet(obj),
  removeBetAtIndex: (obj) => dispatch.betslip.removeBetAtIndex(obj),
  getSportEventByCode: (obj) => dispatch.events.getSportEventByCode(obj)
});

export default withRouter(connect(mapState, mapDispatch)(withTranslation('common')(MarketsGrid)));
